// extracted by mini-css-extract-plugin
module.exports = {"modal":"invited-modal_modal__eRYXQ","copyIcon":"invited-modal_copyIcon__r2_md","copied":"invited-modal_copied__SU_xs"};